// extracted by mini-css-extract-plugin
export default {"header":"header_header__6INJw","user":"header_user__TtCmb","menubar":"header_menubar__F8JqD"};